import React, { Component } from 'react';
import MasterStringsService from '../Services/MasterStringsService.js';
import MasterStringsList from '../Components/MasterStringsList.js';
import { withApi } from '../Providers/WebServiceProvider.js';

class EditMaster extends Component
{
	constructor(props) {
		super(props);

		this.state = {
			strings: [],
			isLoaded: false
		}

		this.stringsService = new MasterStringsService(props.webServiceContext.getApi());
	}

	fetchStrings() {
		var that = this;

		this.setState({ isLoaded: false });

		this.stringsService.retrieve()
			.then(function (results) {
				that.setState({ strings: results, isLoaded: true });
			})
			.catch(function () {
				that.setState({ strings: [], isLoaded: true });
			});
	}

	componentDidMount() {
		this.fetchStrings();
	}

  render () {
  	if (this.state.isLoaded) {
	 	  return (
	 	  	<div className="section">
		 	  	<div className="page-section">
 	  				<MasterStringsList updater={this.stringsService.bulk} strings={this.state.strings} />
				 	</div>
				</div>
		  );
  	} else {
  		return ('Loading...');
  	}
  }
}

export default withApi(EditMaster);


// WEBPACK FOOTER //
// ./src/Pages/EditMaster.js